/**
 * Media Statement — the media panel's play/pause control.
 *
 * bf_media() renders the video muted, looping and decorative; this gives it the
 * control the design shows so the motion can be stopped.
 */
document.querySelectorAll( '.block-media-statement [data-media-toggle]' ).forEach( ( button ) => {
	const panel = button.closest( 'div' );
	const video = panel && panel.querySelector( 'video' );

	if ( ! video ) {
		button.remove();

		return;
	}

	const label = button.querySelector( '[data-toggle-label]' );
	const strings = {
		pause: label ? label.textContent : 'Pause video',
		play: button.dataset.playLabel || 'Play video',
	};

	const sync = () => {
		const playing = ! video.paused;

		button.setAttribute( 'aria-pressed', playing ? 'true' : 'false' );

		if ( label ) {
			label.textContent = playing ? strings.pause : strings.play;
		}
	};

	button.addEventListener( 'click', () => {
		if ( video.paused ) {
			video.play();
		} else {
			video.pause();
		}
	} );

	video.addEventListener( 'play', sync );
	video.addEventListener( 'pause', sync );

	sync();
} );
